import { AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import type { ConsistencyIssue } from '@/lib/murabaha-consistency';

interface Props {
  issues: ConsistencyIssue[];
  className?: string;
}

export default function ConsistencyBadge({ issues, className }: Props) {
  if (!issues || issues.length === 0) return null;

  const primary = issues[0];

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            className={`text-xs border-0 bg-destructive/10 text-destructive gap-1 cursor-help ${className || ''}`}
            onClick={e => e.stopPropagation()}
          >
            <AlertTriangle size={11} />
            {primary.label}
            {issues.length > 1 && <span className="opacity-70">+{issues.length - 1}</span>}
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <ul className="space-y-1 text-xs">
            {issues.map(i => (
              <li key={i.code}>• {i.detail}</li>
            ))}
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
